'use client';

import { SecurityMfa as Section } from '../../components/UserProfile/SecuritySections';
import { createSection } from '../createSection';

export const UserProfileMfaSection = createSection('UserProfileMfaSection', Section);
